import React from 'react';
import { Grid } from '@mui/material';
import PropTypes from 'prop-types';
import ReportCardContainer from './ReportCardContainer';
import { CollapseCard } from '@totalsoft/rocket-ui';

const ReportsList = ({ reports }) => {
  return (
    <Grid container spacing={2} my={2}>
      {reports.map(r => {
        return (
          <Grid item xs={12} key={r}>
            <CollapseCard key={`card_report`} title={r.reportName} toggleOnHeaderClick>
              <ReportCardContainer reportId={r.reportId} pushReportName={() => {}} />
            </CollapseCard>
          </Grid>
        );
      })}
    </Grid>
  );
};

ReportsList.propTypes = {
  reports: PropTypes.array.isRequired
};

export default ReportsList;
